export default __webpack_public_path__ + "static/media/projects_ladning_page.40eae3de.jpeg";